import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import HomeCogGraphic from './HomeCogGraphic';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const HomeHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner" style={{ maxWidth: '1300px' }}>
            <div className="lp-hero-copy">
                <div className="lp-badge lp-badge--up" data-lp-reveal><span />AI-powered transaction readiness</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60" style={{ fontSize: 'clamp(40px, 6vw, 60px)', lineHeight: 1.08 }}>
                    The UK's leading low-cost platform for <span className="lp-accent">automated SME transaction readiness and diligence</span>
                </h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120" style={{ fontSize: '19px' }}>70% of SME investment/exit transactions historically not diligenced due to cost. Changing a process that used to take weeks and cost tens of thousands, into one which takes you days and costs from £100 pa. Quicker deals. Less cost. Higher valuations. Saving you time and hassle.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <Link className="lp-btn lp-btn--primary" to={ROUTES.REGISTER}>Get started free</Link>
                    <a className="lp-btn lp-btn--outline-blue" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
                </div>
                <p className="lp-hero-trust" data-lp-reveal data-lp-delay="240">Trusted by 50+ investors, advisors, and growing companies · No credit card required</p>
            </div>

            <div className="lp-hero-art">
                <HomeCogGraphic />
            </div>
        </div>
    </section>
);

export default HomeHeroSection;
